export enum SellerMarketplaceTab {
    MyEngagement = 1,
    EngagementDocuments = 2,
    EngagementTimeline = 3,
    Buyers = 4,
    DeadlineDocket = 5,
    DataAndDocs = 6,
    Settings = 7,
    CommsHub = 8,
    EngagementHistory = 9,
    SellerProfile = 10,
    DataRoomLayout = 11,
    VDRAccess = 12,
    Lois = 13,
    FAQs = 14,
    LoiComparison = 15,
}

export const SellerMarketplaceTabs = [
    {
        id: SellerMarketplaceTab.MyEngagement,
        label: 'My Engagement',
        tooltip: 'Overview of your engagement status and key details.',
    },
    {
        id: SellerMarketplaceTab.EngagementDocuments,
        label: 'Engagement Documents',
        tooltip: 'View and manage documents related to your engagement.',
    },
    {
        id: SellerMarketplaceTab.EngagementTimeline,
        label: 'Engagement Timeline',
        tooltip: 'Track milestones and progress of your engagement.',
    },
    {
        id: SellerMarketplaceTab.DeadlineDocket,
        label: 'Deadline Docket',
        tooltip: 'Track upcoming deadlines and action items.',
    },
    {
        id: SellerMarketplaceTab.DataAndDocs,
        label: 'Practice Data & Docs',
        tooltip: 'Access and manage practice data and documents.',
    },
    {
        id: SellerMarketplaceTab.SellerProfile,
        label: 'Seller Profile',
        tooltip: 'View and update your seller profile information.',
    },
    {
        id: SellerMarketplaceTab.Buyers,
        label: 'Buyers',
        tooltip: 'View and manage buyer activity and profiles.',
    },
    {
        id: SellerMarketplaceTab.CommsHub,
        label: 'Comms Hub',
        tooltip: 'Communicate with your advisory team and buyers.',
    },
    {
        id: SellerMarketplaceTab.LoiComparison,
        label: 'LOI Comparison',
        tooltip: 'Compare and review Letters of Intent from buyers.',
    },
    {
        id: SellerMarketplaceTab.DataRoomLayout,
        label: 'Data Room',
        tooltip: 'Manage and share documents in your secure data room.',
    },
    {
        id: SellerMarketplaceTab.EngagementHistory,
        label: 'Engagement History',
        tooltip: 'Review the history and activity log of your engagement.',
    },
    { id: SellerMarketplaceTab.Settings, label: 'Settings' },
    { id: SellerMarketplaceTab.VDRAccess, label: 'VDR Access' },
    { id: SellerMarketplaceTab.Lois, label: 'LOIs' },
    { id: SellerMarketplaceTab.FAQs, label: 'FAQs' },
];
